/**
 * Providers globais para configuração de datas em componentes standalone
 *
 * Este ficheiro centraliza a configuração de datas para garantir consistência
 * em todo o projeto, especialmente em componentes standalone que não herdam
 * automaticamente os providers do AppModule.
 *
 * Configuração:
 * - Locale: Português de Portugal (pt-PT)
 * - Formato de exibição: DD-MM-YYYY
 * - Formato de input: DD-MM-YYYY, DDMMYYYY, DD/MM/YYYY
 * - Adaptador: DayjsDateAdapter (compatível com dayjs)
 *
 * @example
 * // Importar nos componentes standalone:
 * import { DATE_ADAPTER_PROVIDERS } from 'src/app/shared/providers/date-adapter.providers';
 *
 * @Component({
 *   selector: 'app-my-component',
 *   standalone: true,
 *   providers: [DATE_ADAPTER_PROVIDERS]
 * })
 */

import { Provider } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DayjsDateAdapter } from '../adapters/dayjs-date-adapter';
import { MY_DATE_FORMAT } from '../services/datetime.service';

/**
 * Providers para configuração de datas em componentes standalone
 * Garante que todos os datepickers usam:
 * - Locale português (pt-PT)
 * - Formato DD-MM-YYYY
 * - DayjsDateAdapter
 */
export const DATE_ADAPTER_PROVIDERS: Provider[] = [
  {
    provide: DateAdapter,
    useClass: DayjsDateAdapter,
    deps: [MAT_DATE_LOCALE],
  },
  {
    provide: MAT_DATE_LOCALE,
    useValue: 'pt-PT',
  },
  {
    provide: MAT_DATE_FORMATS,
    useValue: MY_DATE_FORMAT,
  },
];
